import React from "react";

export default function DonorGemIcon({ className = "", outline = false }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path
        className="donor-gem-icon__shell"
        fill={outline ? "none" : "currentColor"}
        stroke="currentColor"
        strokeWidth={outline ? 1.35 : 0}
        strokeLinejoin="round"
        d="M12 2.25 19.75 8.5 12 21.75 4.25 8.5 12 2.25Z"
      />
      <path
        className="donor-gem-icon__crown"
        fill="none"
        stroke="currentColor"
        strokeWidth={outline ? 1.1 : 0.85}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.25 8.5h15.5M8.25 8.5 12 5.25l3.75 3.25"
      />
      <path
        className="donor-gem-icon__facet"
        fill="none"
        stroke="currentColor"
        strokeWidth={outline ? 0.9 : 0.75}
        strokeLinecap="round"
        d="M12 5.25v16.5M8.25 8.5 12 11.75l3.75-3.25"
      />
    </svg>
  );
}
